var map = {
	"./symbol_0.png": 11154,
	"./symbol_1.png": 32699,
	"./symbol_10_x10.png": 68897,
	"./symbol_10_x100.png": 39829,
	"./symbol_10_x1000.png": 37937,
	"./symbol_10_x12.png": 93523,
	"./symbol_10_x15.png": 38652,
	"./symbol_10_x2.png": 67438,
	"./symbol_10_x20.png": 25324,
	"./symbol_10_x25.png": 58577,
	"./symbol_10_x250.png": 36293,
	"./symbol_10_x3.png": 13015,
	"./symbol_10_x4.png": 64024,
	"./symbol_10_x5.png": 85153,
	"./symbol_10_x50.png": 99189,
	"./symbol_10_x500.png": 43729,
	"./symbol_10_x6.png": 54570,
	"./symbol_10_x8.png": 14484,
	"./symbol_2.png": 51488,
	"./symbol_3.png": 75689,
	"./symbol_4.png": 25718,
	"./symbol_5.png": 63167,
	"./symbol_6.png": 77892,
	"./symbol_7.png": 41133,
	"./symbol_8.png": 65869,
	"./symbol_9.png": 78083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87061;